import React, { useMemo } from "react";
import { Skeleton } from "@mantine/core";
import { Bar } from "react-chartjs-2";
import { loadingStates } from "../../utilities/utilities";

const YEARS = Array.from({ length: 8 }, (_, i) => 2022 + i);

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: "Agreements",
      },
      grid: {
        display: false,
      },
      ticks: {
        precision: 0,
      },
    },
    x: {
      title: {
        display: true,
        text: "Year",
      },
      grid: {
        display: false,
      },
    },
  },
};

function AgreementGraph1({ configs }) {
  const isLoading = configs.loading === loadingStates.LOADING;

  const yearlyData = useMemo(() => {
    const agreementByYear = configs?.data?.agreementByYear || [];
    return YEARS.map((year) => {
      const yearData = agreementByYear.find((el) => el.year === year - 2000);
      return yearData ? yearData._count.id : 0;
    });
  }, [configs?.data?.agreementByYear]);

  const showChart = !isLoading && Array.isArray(configs?.data?.agreementByYear);

  return (
    <div className="w-full h-full">
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h3 className="mb-3 text-sm font-semibold capitalize text-gray-700">
          Yearly stats
        </h3>

        {isLoading ? (
          <Skeleton height={220} radius="md" />
        ) : showChart ? (
          <div className="h-56 w-full">
            <Bar
              data={{
                labels: YEARS.map(String),
                datasets: [
                  {
                    label: "Agreements",
                    backgroundColor: "rgb(70, 189, 225)",
                    barThickness: 28,
                    borderRadius: 6,
                    data: yearlyData,
                  },
                ],
              }}
              options={chartOptions}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default AgreementGraph1;
